<template lang="html">
  <div class="billingData">
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <h6 class="element-header">{{ t('netsendBillingDataHeader', 'netsendBillingDataHeader')}}</h6>
          <div class="element-box">
            <div>
              <div class="element-info">
                <div class="row">
                  <div class="col-12 col-sm-6 col-md-8">
                    <div class="element-info-with-icon">
                      <div class="element-info-icon">
                        <span class="os-icon os-icon-search2"></span>
                      </div>
                      <div class="element-info-text">
                        <h5 class="element-inner-header">{{ t('netsendBillingDataTitle','netsendBillingDataTitle') }}</h5>
                        <div class="element-inner-desc">{{ t('netsendBillingDataDesc','netsendBillingDataDesc') }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-3 col-md-4">
                    <i id="billingDataToggle" v-b-toggle.search class="os-icon os-icon-arrow-up float-right text-netsend-blue showhand"></i>
                  </div>
                </div>
              </div>
              <b-collapse id="search" ref="searchForm" v-model="visibleSearchBox">
                <form v-on:submit.prevent="requestBillingData">
                  <div class="col-lg-12 row">
                    <div class="col-lg-2">
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label for="batch-ref" class="d-block text-center">{{t('searchLabelBatchRef','searchLabelBatchRef') }}</label>
                          <input id="batch-ref" v-model="billingDataRequest.batch_reference" class="form-control text-center" :placeholder="t('searchLabelBatchRef','searchLabelBatchRef')" type="text">
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label for="batch-type" class="d-block text-center">{{t('searchLabelBatchType','searchLabelBatchType') }}</label>
                          <select id="batch-type" v-model="billingDataRequest.batch_type" class="form-control custom-select text-capitalize">
                            <option :value="null" selected>{{ t('selectAll','selectAll') }}</option>
                            <option v-if="batchTypes" v-for="batchType in batchTypes" :value="batchType.id" :key="batchType.id">{{ batchType.name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label for="batch-num" class="d-block text-center">{{ t('searchLabelInvoiceNo','searchLabelInvoiceNo') }}</label>
                          <input id="batch-num" v-model="billingDataRequest.invoice_number" class="form-control text-center" :placeholder="'0'" type="text">
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2">
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label for="batch-after" class="d-block text-center">{{t('searchLabelBatchDAfter','searchLabelBatchDAfter') }}</label>
                          <datePicker id="batch-after" v-model="billingDataRequest.upload_after" class="form-control text-center" :config="datePickerAfterConfig" :placeholder="t('searchLabelBatchDAfter','searchLabelBatchDAfter')"></datePicker>
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label for="batch-before" class="d-block text-center">{{ t('searchLabelBatchDBefore','searchLabelBatchDBefore') }}</label>
                          <datePicker id="batch-before" v-model="billingDataRequest.upload_before" class="form-control text-center" :config="datePickerBeforeConfig" :placeholder="t('searchLabelBatchDBefore','searchLabelBatchDBefore')">
                          </datePicker>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12 row justify-content-between">
                    <div class="col-lg-2">
                      <b-input-group class="form-group col-lg-12">
                        <b-input-group-prepend>
                          <label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
                        </b-input-group-prepend>
                        <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                      </b-input-group>
                    </div>
                    <div class="form-group col-lg-2 align-self-center">
                      <button v-if="!isBusy" class="btn btn-primary float-right" type="submit">{{ t('searchButtonText','searchButtonText') }}</button>
                      <b-button v-if="isBusy" class="btn btn-primary float-right" variant="primary" disabled>
                        <b-spinner small type="grow"></b-spinner>
                        {{ t('searchButtonText','searchButtonText') }}
                      </b-button>
                    </div>
                  </div>
                </form>
              </b-collapse>
            </div>
          </div>
          <div class="element-box" style="overflow: hidden;" v-if="billingDataEntries">
            <div class="element-box-tp results-height-fix">
              <div class="controls-below-table">
                <div class="col-sm-12 col-md-6 table-records-info px-0">
                  <p v-if="filter != null && filter.length" class="font-weight-bold mb-0">{{ filteredRows }}</p>
                  <p v-else>
                    <template v-if="totalRows == 1">
                    {{totalRows}} {{ t('billingDataFoundLabel','billingDataFoundLabel') }}
                    </template>
                    <template v-else>
                    {{totalRows}} {{ t('billingDataFoundLabel','billingDataFoundLabel') }}
                    </template>
                  </p>
                </div>
                <div class="col-sm-12 col-md-4">
                  <b-pagination ref="paginationTop" class="float-right mb-0" @change="manualPagination" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" aria-controls="billing-data-table">
                  </b-pagination>
                </div>
                <div class="col-sm-12 col-md-2 px-0">
                  <b-input-group class="form-group col-lg-12 px-0">
                    <b-input-group-prepend>
                      <label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
                    </b-input-group-prepend>
                    <b-form-select v-model="perPage" @change="requestBillingData" :options="pageOptions"></b-form-select>
                  </b-input-group>
                </div>
              </div>
              <transition mode="out-in">
                <div key="1" id="table-main" class="table-responsive">
                  <b-table id="billing-data-table" striped hover bordered responsive class="mt-3" :busy.sync="isBusy" :fields="fields" :items="billingDataList" no-sort-reset :sort-desc.sync="sortDesc"
                  :total-rows="totalInvoices" per-page="0" :currentPage="currentPage" :filter="filter" @filtered="onFiltered" show-empty>
                    <template class="busy-row" v-slot:table-busy>
                      <vcl-table :rows="parseInt(perPage)" :columns="7"></vcl-table>
                    </template>
                    <template v-slot:head(reference)="data">
                      <span >{{ t(data.label, data.label) }}</span>
                    </template>
                    <template v-slot:head(invoice_no)="data">
                      <span >{{ t(data.label, data.label) }}</span>
                    </template>
                    <template v-slot:head(type_name)="data">
                      <span >{{ t(data.label, data.label) }}</span>
                    </template>
                    <template v-slot:head(total_docs)="data">
                      <span >{{ t(data.label, data.label) }}</span>
                    </template>
                    <template v-slot:head(deleted_docs)="data">
                      <span >{{ t(data.label, data.label) }}</span>
                    </template>
                    <template v-slot:head(dataxferred_docs)="data">
                      <span >{{ t(data.label, data.label) }}</span>
                    </template>
                    <template v-slot:head(total_emailed)="data">
                      <span >{{ t(data.label, data.label) }}</span>
                    </template>
                    <template v-slot:head(total_faxed)="data">
                      <span >{{ t(data.label, data.label) }}</span>
                    </template>
                    <template v-slot:head(total_posted)="data">
                      <span >{{ t(data.label, data.label) }}</span>
                    </template>
                    <template v-slot:head(online_docs)="data">
                      <span >{{ t(data.label, data.label) }}</span>
                    </template>
                    <template v-slot:cell(reference)="data">
                      <router-link :to="{ path: '/documents/search?page=1&per_page=20&batch=' + data.item.batch_id }">{{ data.item.reference.trim() }}</router-link>
                    </template>
                    <template v-slot:cell(invoice_number)="data">
                      <span>{{ data.item.invoice_number }}</span>
                    </template>
                    <template v-slot:cell(batch_type)="data">
                      <span>{{ data.item.batch_type }}</span>
                    </template>
                    <template v-slot:cell(total_docs)="data">
                      <span>{{ data.item.total_docs }} ( {{ data.item.total_pages}} )</span>
                    </template>
                    <template v-slot:cell(deleted_docs)="data">
                      <span>{{ data.item.deleted_docs }} ( {{ data.item.deleted_pages}} )</span>
                    </template>
                    <template v-slot:cell(dataxferred_docs)="data">
                      <span>{{ data.item.dataxferred_docs }} ( {{ data.item.dataxferred_pages }} )</span>
                    </template>
                    <template v-slot:cell(total_emailed)="data">
                      <span>{{ data.item.total_emailed }} ( <template v-if="data.item.pages_emailed">{{ data.item.pages_emailed}}</template><template v-else>0</template> )</span>
                    </template>
                    <template v-slot:cell(total_faxed)="data">
                      <span>{{ data.item.total_faxed }} ( <template v-if="data.item.pages_faxed">{{ data.item.pages_faxed}}</template><template v-else>0</template> )</span>
                    </template>
                    <template v-slot:cell(total_posted)="data">
                      <span>{{ data.item.total_posted }} ( <template v-if="data.item.pages_posted">{{ data.item.pages_posted}}</template><template v-else>0</template> )</span>
                    </template>
                    <template v-slot:cell(online_docs)="data">
                      <span>{{ data.item.online_docs }} ( {{ data.item.online_pages}} )</span>
                    </template>
                    <template v-if="currencies" v-for="currency in currencies" v-slot:[`cell(${currency})`]="data">
                      <span>{{ data.item.posting_charge[currency] ? data.item.posting_charge[currency] : 0 }}</span>
                    </template>
                    <template slot="empty" slot-scope="items">
                      <div class="text-center"> {{ t('noEntriesFound','noEntriesFound') }}</div>
                    </template>
                  </b-table>
                </div>
              </transition>
              <div class="controls-below-table pt-4">
                <div class="col-sm-12 col-md-6 table-records-info px-0" v-if="billingDataEntries">
                  <button @click="downloadBillingDataCSV()" class="btn btn-primary">{{ t('downloadBillingDataCSVBtn', 'downloadBillingDataCSVBtn') }}</button>
                  <p v-if="filter != null && filter.length" class="font-weight-bold mb-0 inline-display px-2">{{filteredRows}}</p>
                  <p v-else class="mb-0 inline-display px-2">
                      <template v-if="totalRows == 1">
                      {{totalRows}} {{ t('billingDataFoundLabel', 'billingDataFoundLabel') }}
                      </template>
                      <template v-else>
                      {{totalRows}} {{ t('billingDataFoundLabel', 'billingDataFoundLabel') }}
                      </template>
                  </p>
                </div>
                <div class="col-sm-12 col-md-4">
                  <b-pagination ref="paginationBottom" class="float-right mb-0" @change="manualPagination" :total-rows="totalInvoices" :per-page="perPage" v-model="currentPage" aria-controls="billing-data-table">
                  </b-pagination>
                </div>
                <div class="col-sm-12 col-md-2 px-0">
                  <b-input-group class="form-group col-lg-12 px-0">
                    <b-input-group-prepend>
                      <label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
                    </b-input-group-prepend>
                    <b-form-select v-model="perPage" :options="pageOptions" @change="requestBillingData"></b-form-select>
                  </b-input-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import moment from 'moment'
import datePicker from 'vue-bootstrap-datetimepicker'
import { mapGetters } from 'vuex'
import { backendUrl } from '@/helpers/backendUrl.js'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import { VclTable } from 'vue-content-loading'

export default {
  name: 'NetsendBillingData',
  data() {
    return {
      visibleSearchBox: true,
      pageOptions: [10, 20, 50, 100],
      currentPage: this.$route.query.currentPage ? this.$route.query.currentPage : 1,
      perPage: this.$route.query.perPage ? this.$route.query.perPage : 20,
      isBusy: false,
      maxDate: '',
      minDate: '',
      totalRows: 0,
      rowEmpty: false,
      currencyList: null,
      billingDataList: null,
      billingDataRequest: {
        batch_reference: this.$route.query.batch_reference ? this.$route.query.batch_reference : null,
        batch_type: this.$route.query.batch_type ? this.$route.query.batch_type : null,
        invoice_number: this.$route.query.invoice_number ? this.$route.query.invoice_number : null,
        upload_after: this.$route.query.upload_after ? this.$route.query.upload_after : null,
        upload_before: this.$route.query.upload_before ? this.$route.query.upload_before : null
      },
      searchRequest: [],
      datePickerAfterConfig: {
        icons: {
          time: 'os-icon os-icon-calendar-time',
          date: 'os-icon os-icon-basic-2-259-calendar',
          up: 'os-icon os-icon-chevron-up',
          down: 'os-icon os-icon-chevron-down',
          previous: 'os-icon os-icon-chevron-left',
          next: 'os-icon os-icon-chevron-right',
          clear: 'os-icon os-icon-trash',
          close: 'os-icon os-icon-cancel-circle'
        },
        showClear: true
      },
      datePickerBeforeConfig: {
        icons: {
          time: 'os-icon os-icon-calendar-time',
          date: 'os-icon os-icon-basic-2-259-calendar',
          up: 'os-icon os-icon-chevron-up',
          down: 'os-icon os-icon-chevron-down',
          previous: 'os-icon os-icon-chevron-left',
          next: 'os-icon os-icon-chevron-right',
          clear: 'os-icon os-icon-trash',
          close: 'os-icon os-icon-cancel-circle'
        },
        minDate: moment('1979-01-01', this.datePickerFormat),
        showClear: true
      },
      sortDesc: true,
      filter: null,
      filteredRows: ''
    }
  },
  components: {
    Navbar,
    datePicker,
    VclTable
  },
  computed:{
    ...mapGetters(['allTemplateDetails']),

    backendLink() {
      return backendUrl()
    },

    billingDataEntries() {
      return this.billingDataList
    },

    currencies() {
      return this.currencyList
    },

    totalInvoices() {
      return this.totalRows
    },

    datePickerFormat: {
      get() {
        if(this.$store.getters.allTemplateDetails && this.$store.getters.allTemplateDetails.datePickerFormat) {
          let dateformat = this.$store.getters.allTemplateDetails.datePickerFormat.replace(/-/g, '/')
          return dateformat
        } else {
          return "DD-MM-YYYY"
        }
      }
    },

    batchTypes: {
      get() {
        return this.$store.getters.getBatchTypes
      },
      set(batchTypes) {
        this.$store.commit('setBatchTypes', batchTypes)
      }
    },

    fields() {
      let fields = [
        {key: 'reference', label: 'tableHeadBatchReference', sortable: true, thClass: 'brand-color'},
        {key: 'invoice_no', label: 'tableHeadInvoiceNo', tdClass: 'cell-small', thClass: 'brand-color'},
        {key: 'type_name', label: 'tableHeadInvoiceTypeName', sortable: true, thClass: 'brand-color'},
        {key: 'total_docs', label: 'tableHeadTotalDocs', tdClass: 'cell-small', sortable: true, thClass: 'brand-color'},
        {key: 'deleted_docs', label: 'tableHeadDeletedDocs', tdClass: 'cell-small', sortable: false, thClass: 'brand-color'},
        {key: 'dataxferred_docs', label: 'tableHeadDataxferredDocs', tdClass: 'cell-small', sortable: true, thClass: 'brand-color'},
        {key: 'total_emailed', label: 'tableHeadTotalMailed', tdClass: 'cell-small', sortable: false, thClass: 'brand-color'},
        {key: 'total_faxed', label: 'tableHeadTotalFaxed', tdClass: 'cell-small', sortable: false, thClass: 'brand-color'},
        {key: 'total_posted', label: 'tableHeadTotalPosted', tdClass: 'cell-small', sortable: false, thClass: 'brand-color'},
        {key: 'online_docs', label: 'tableHeadOnlineDocs', tdClass: 'cell-small', sortable: false, thClass: 'brand-color'}
        //{key: 'postage_charge', label: 'tableHeadPostageCharge', tdClass: 'cell-small', sortable: false, thClass: 'brand-color'}
      ]

      if(this.billingDataList && !this.rowEmpty && this.currencyList && this.currencyList.length > 0) {
        this.currencyList.forEach(element => {
          let currencyColumn = {key: element, label: 'tableHeadPostageCharge' + ' (' + element + ')', isCurrencyColumn: true, tdClass: 'cell-small', sortable: false, thClass: 'brand-color'}
          fields.push(currencyColumn)
        })
      }

      return fields
    },

    datePickerFormat: {
      get() {
        if(this.$store.getters.allTemplateDetails && this.$store.getters.allTemplateDetails.datePickerFormat) {
          let dateformat = this.$store.getters.allTemplateDetails.datePickerFormat.replace(/-/g, '/')
          return dateformat
        } else {
          return "DD-MM-YYYY"
        }
      }
    },
  },
  created() {
    this.$store.dispatch('getBatchTypes')

    this.datePickerAfterConfig.format = this.datePickerFormat
      this.datePickerBeforeConfig.format = this.datePickerFormat

    let todaysDate = moment(new Date(), this.datePickerFormat)
    this.datePickerAfterConfig.maxDate = todaysDate
    this.datePickerBeforeConfig.maxDate = todaysDate

    if(Object.keys(this.$route.query).length > 0) {
      this.requestBillingData()
    }
    
  },
  methods: {
    requestBillingData() {
      // prepare request params
      Object.keys(this.billingDataRequest).forEach(function(key) {
        if(this.billingDataRequest[key] && this.billingDataRequest[key] !== "" && this.billingDataRequest[key] != null)
        {
          this.searchRequest[key] = this.billingDataRequest[key]
        } else {
          if(this.searchRequest[key]) {
            delete this.searchRequest[key]
          }
        }
      }, this)

      // update route params
      this.$router.replace({'query': null});
      this.$router.push({ query: { ...this.$route.query, page: this.currentPage, per_page: this.perPage, ...this.searchRequest } })
        
      this.isBusy = true

      this.$store.dispatch('billingDataStore/getBillingDataList', 
      {
        perPage: this.perPage,
        currentPage: this.currentPage,
        ...this.searchRequest
      }).then(response => {
        this.isBusy = false
        this.visibleSearchBox = false
        
        if(response.invoices.length < 1) {
          this.rowEmpty = true
        } else {
          this.rowEmpty = false
        }        

        this.totalRows = response.total_invoices
        this.billingDataList = response.invoices
        this.currencyList = response.currencyArray

        this.manualPagination(this.currentPage)
      })
    },

    downloadBillingDataCSV() {
      this.$store.dispatch('tokenStore/createDownloadToken', null).then(response => {
          let accessToken = response
          let queryParams = accessToken

          if(this.billingDataRequest.upload_before) {
            let dataBefore = this.billingDataRequest.upload_before
            dataBefore = dataBefore.replaceAll("/", "-")
            queryParams = queryParams + '/' + dataBefore
          }
          if(this.billingDataRequest.upload_after) {
            let dataAfter = this.billingDataRequest.upload_after
            dataAfter = dataAfter.replaceAll("/", "-")
            queryParams = queryParams + '/' + dataAfter
          }

          let downloadUrl = backendUrl() + '/downloadBillingDataCSV/' + queryParams
          window.open(downloadUrl, '_blank')
      })
    },

    onFiltered(filteredItems) {
      this.filteredRows = filteredItems.length
      this.currentPage = 1
    },

    manualPagination(newPage) {
        let page = parseInt(newPage)

        if(this.currentPage !== page) {
          this.currentPage = page
          this.requestBillingData()
        }

        if(this.$refs.paginationTop) {
          if(this.currentPage != this.$refs.paginationTop.currentPage) {
            this.$refs.paginationTop.currentPage = this.currentPage
          }
        }

        if(this.$refs.paginationBottom) {
          if(this.currentPage != this.$refs.paginationBottom.currentPage) {
            this.$refs.paginationBottom.currentPage = this.currentPage
          }
        }
      },
  },
  watch: {
    date_from(date) {
      if(date) {
        let dateFrom = moment(date, this.datePickerFormat)
        this.datePickerBeforeConfig.minDate = dateFrom
      } else {
        this.datePickerBeforeConfig.minDate = moment(new Date('1979-01-01'), this.datePickerFormat)
      }
    }
  },
}
</script>

<style scoped>
  .table-responsive >>> .cell-small{
    min-width: 15px;
    text-align: center;
    white-space: nowrap;
  }
  .table-responsive  >>> .brand-color {
    background-color: #047bf8 !important;
    color: white !important;
  }
  .inline-display {
    display: inline-block;
  }
  .width-control{
    max-width: 90vw !important;
    margin: 0 auto;
  }
  #billingDataToggle {
    font-size: 1.2rem;
    font-weight: bold;
    display:inline-block;
    -moz-transition: all .5s linear;
    -webkit-transition: all .5s linear;
    transition: all .5s linear;
  }
  #billingDataToggle.collapsed {
    -moz-transform:rotate(180deg);
    -webkit-transform:rotate(180deg);
    transform:rotate(180deg);
  }
</style>